import src from "IMAGE";
export default { src, width: 418, height: 249, blurWidth: 0, blurHeight: 0};
